<template>
  <div>
    <header class="header-global fixed-top">
      <base-nav
        class="navbar-main headroom"
        id="navbar-main"
        :type="navbarType ? navbarType : 'anhod1'"
        effect="dark"
        expand
      >
        <router-link
          slot="brand"
          class="navbar-brand mr-lg-5"
          to="/recouvrement"
        >
          <img src="img/brand/logo.png" alt="logo" style="height: 70px;" />
          Arcos
        </router-link>

        <ul
          class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto"
        >
          <li class="nav-item">
            <router-link to="/">
              <a class="nav-link"
                ><i class="ni ni-curved-next"></i> Retourner à l'accueil</a
              >
            </router-link>
          </li>
        </ul>
      </base-nav>
    </header>
    <div class="pt-100 pl-6 pr-6 pb-100 petit">
      <br />
      <h2 id="main" style="text-align: center; color: #222222">
        Politique de données personnelles
      </h2>
      <br />
      Notre société respecte la confidentialité des données de toutes les
      personnes concernées par le traitement des dossiers. Nous nous engageons à
      assurer le meilleur niveau de protection de vos données personnelles dans
      le respect de la règlementation. En vertu de votre contrat initial, vos
      données personnelles peuvent être transmises à un cabinet de recouvrment à
      des fins de recouvrement si les remboursements ne sont pas effectués comme
      convenu, en cas de recouvrement de créances impayées. Afin de pouvoir
      mener à bien notre prestation de recouvrement et de relance, nous
      utilisons alors les données personnelles qui nous ont été fournies. Nous
      refusons de traiter vos données personnelles sans fondement juridique.
      Nous travaillons sur la base d'un mandat de recouvrement ou d'une
      convention de recouvrement. C'est seulement à partir de ce moment là que
      nous utilisons les données personnelles collectées. Le traitement de vos
      données personnelles nécessaire au recouvrement de créances est autorisé,
      et ce même si vous n’y avez pas consenti, car votre accord n’est pas
      obligatoire. Nous pouvons être amenés à vérifier ces données, à les
      compléter si cela est nécessaire.
      <br /><br /><b
        >Quelles données personnelles traitez-vous à mon sujet et pourquoi ?</b
      >
      <br />
      Nous détenons et utilisons principalement les informations permettant de
      vous identifier et de vous contacter : nom, prénom, téléphone, mail,
      adresse postale etc...
      <br /><br />
      Nous utilisons aussi vos données personnelles pour garantir le respect des
      bonnes pratiques en matière de recouvrement et pour les éventuelles
      formations de nos collaborateurs. Nous vous informons que votre
      conversation téléphonique est susceptible d’être enregistrée, pour des
      raisons d’évaluation de la qualité des appels.
      <br />
      Vous pouvez vous opposer à cet enregistrement en le signalant au début de
      chaque conversation téléphonique avec votre gestionnaire.
      <br /><br />

      <b>Comment mes données personnelles sont collectées ?</b><br />
      Vos données personnelles sont collectées par le transfert des dossiers de
      la part de nos clients. Dans le cadre de nos échange avec vous, vous
      pouvez être amené à nous communiquer des informations personnelles
      complémentaires.
      <br />
      <br />
      <b>Mes données personnelles peuvent-elles être partagées ?</b>
      <br />
      Vos données ne sont pas utilisées à des fins de prospection commerciale.
      <br />
      <br />
      Vos données personnelles peuvent être partagés principalement dans le
      cadre d'un recouvrement judiciaire, auprès des auxiliaires de justice :
      avocats, huissiers etc...
      <br /><br />
      Notre service informatique, dans le cadre de la maintenance et du
      développement des outils informatiques et digitaux peut être amené à
      utiliser vos données.
      <br /><br />
      Certaines de vos données personnelles peuvent être partagés auprès de
      partenaires dans le cadre du traitement de votre dossier : banque pour le
      paiement et les prélèvements, société de routage SMS etc...
      <br /><br />

      <b
        >Mes données personnelles seront-elles transférées vers un autre pays
        ?</b
      >
      <br /><br />
      Non, l'ensemble de nos locaux sont situés en France. Nos partenaires sont
      tous situés en France.
      <br /><br />

      <b>Pendant combien de temps conservez-vous mes données personnelles ?</b>
      <br />

      Nous conserverons vos données tant que nous aurons un intérêt légitime à
      les conserver. C'est à dire jusqu'au règlement amiable ou judiciaire de
      vos impayés ou au classement irrecouvrable de votre dossier et même
      au-delà, jusqu’à expiration du délai de prescription pour pouvoir nous
      défendre contre des actions en justice.
      <br /><br />

      <b>Quels sont mes droits ?</b><br />
      Vous pouvez vous adresser à notre société directement pour accéder à vos
      données personnelles. Vous pouvez nous demander des informations
      complémentaires sur le traitement de vos données personnelles.
      <br />
      Vous disposez d’un droit d’accès, de rectification, de suppression et de
      portabilité pour toute information vous concernant auprès de notre
      société, conformément aux dispositions du Règlement Général de Protection
      des Données (RGPD) en date du 27 avril 2016.
      <br />
      <div class="pt-50">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <router-link to="/login/0">
              <base-button block type="anhod2" text-color="white">
                Retourner à l'accueil
              </base-button>
            </router-link>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseNav from "@/components/BaseNav";
export default {
  name: "DonneesPerso",
  components: {
    BaseNav
  }
};
</script>

<style scoped>
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
  padding-block-end: 20rem;
}
@media screen and (max-width: 991px) {
  #main {
    padding-top: 4em;
  }
}
</style>
